import { AgentFilterType, FilterType, PlanTypes, SortDTO } from './Types';

export const DEFAULT_PAGE = 1;
export const COUNT_PER_PAGE = 15;
export const DEFAULT_DEBOUNCE_TIME = 500;
export const MAX_LIMIT = 999999;
export const TickPath = '/image/Landing/Landing-TickOnPlan.png';

export const FixedFeatures = ['Export data to CSV or PDF'];

export const DEFAULT_DURATION = 1;
export const DEFAULT_PLAN = 'Entry';

export const PlanPeriods = [
    { duration: 1, description: 'Monthly', discount: 0 },
    { duration: 12, description: 'Yearly', discount: 0.2 },
];

export const ROUTES = {
    LADNING: '/',

    SIGN_IN: '/sign-in',
    SIGN_UP: '/sign-up',
    VERIFY_EMAIL: '/verify-mail',

    ONBOARDING: '/onboarding',
    MAIN: '/overview',
    PUBLIC_OVERVIEW: '/public-overview',
    COMPETITORS: '/collaboration-partner',
    NOTIFICATIONS: '/notifications',
    VIEWSHARELINK: '/viewsharelink/:uuid',

    SETTING: '/setting',
    EMAIL_UPDATED: '/email-updated',

    TEST: '/test',

    SUBSCRIPTION_SUCCESS: '/subscription/success',
    SUBSCRIPTION_CANCELED: '/subscription/cancel',
    ADD_REQUEST: '/add-request',
};

export const StripeCustomerPortal =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? 'https://billing.stripe.com/p/login/dR6g2ybJ33Ew9Tq8ww'
        : 'https://billing.stripe.com/p/login/test_fZe8x2a4i9UH8ZqeUU';

export const SubscriptionPlans: PlanTypes[] = [
    {
        priceId:
            process.env.REACT_APP_NODE_ENV === 'production'
                ? {
                      month: 'price_1RVwOHHfaSP6XcAkmj2DEKZd',
                      year: 'price_1RVwP9HfaSP6XcAkdVfwN9FV',
                  }
                : {
                      month: 'price_1OzKgsHfaSP6XcAkRFBjRnps',
                      year: 'price_1P7PUEHfaSP6XcAk1KONZXwD',
                  },
        icon: '/image/Plan/Plan-Free-Icon.png',
        title: 'Entry',
        description: 'Perfect for getting started',
        pricePerMonth: 15,
        pricePerYear: 144,
        pricePerYearMonthly: 12,
        maxSwapCount: 2,
        maxPropertyData: 100,
        maxMapSearchPerMonth: 3,
        maxAISearchPerMonth: 3,
    },
    {
        priceId:
            process.env.REACT_APP_NODE_ENV === 'production'
                ? {
                      month: 'price_1RU6AuHfaSP6XcAkntOiKFOI',
                      year: 'price_1RU6GxHfaSP6XcAkVR91W3RC',
                  }
                : {
                      month: 'price_1OzKieHfaSP6XcAkto2cMA20',
                      year: 'price_1P7PTpHfaSP6XcAkqjQrQLAP',
                  },
        icon: '/image/Plan/Plan-Basic-Icon.png',
        title: 'Plus',
        description: 'Ideal for growing businesses',
        pricePerMonth: 30,
        pricePerYear: 288,
        pricePerYearMonthly: 24,
        maxSwapCount: 5,
        maxPropertyData: MAX_LIMIT,
        maxMapSearchPerMonth: MAX_LIMIT,
        maxAISearchPerMonth: MAX_LIMIT,
    },
    {
        priceId:
            process.env.REACT_APP_NODE_ENV === 'production'
                ? {
                      month: 'price_1RVwSTHfaSP6XcAkvGSPg0y9',
                      year: 'price_1RVwShHfaSP6XcAkwI69rGVR',
                  }
                : {
                      month: 'price_1OzKk7HfaSP6XcAkuRsUDush',
                      year: 'price_1P7PScHfaSP6XcAk7gdqzBZZ',
                  },
        icon: '/image/Plan/Plan-Standard-Icon.png',
        title: 'Prime',
        description: 'Best for established businesses',
        pricePerMonth: 55,
        pricePerYear: 528,
        pricePerYearMonthly: 44,
        maxSwapCount: 100,
        maxPropertyData: MAX_LIMIT,
        maxMapSearchPerMonth: MAX_LIMIT,
        maxAISearchPerMonth: MAX_LIMIT,
    },
    {
        priceId:
            process.env.REACT_APP_NODE_ENV === 'production'
                ? {
                      month: 'price_1RVwTfHfaSP6XcAklRuimKS1',
                      year: 'price_1RVwTvHfaSP6XcAkqHeAGer8',
                  }
                : {
                      month: 'price_1OzKlaHfaSP6XcAkoBtJ7XWq',
                      year: 'price_1P7PS1HfaSP6XcAkatFwfHNu',
                  },
        icon: '/image/Plan/Plan-Premium-Icon.png',
        title: 'Pro',
        description: 'Ultimate data experience',
        pricePerMonth: 100,
        pricePerYear: 960,
        pricePerYearMonthly: 80,
        maxSwapCount: MAX_LIMIT,
        maxPropertyData: MAX_LIMIT,
        maxMapSearchPerMonth: MAX_LIMIT,
        maxAISearchPerMonth: MAX_LIMIT,
    },
    {
        priceId:
            process.env.REACT_APP_NODE_ENV === 'production'
                ? {
                      month: 'price_1PAalPHfaSP6XcAkd9ksVyOd',
                      year: 'price_1PAalPHfaSP6XcAkvgTCr47D',
                  }
                : {
                      month: 'price_1OzKgsHfaSP6XcAkRFBjRnps',
                      year: 'price_1P7PUEHfaSP6XcAk1KONZXwD',
                  },
        icon: '/image/Plan/Plan-Free-Icon.png',
        title: 'Free',
        description: 'Perfect for getting started',
        pricePerMonth: 0,
        pricePerYear: 0,
        pricePerYearMonthly: 0,
        maxSwapCount: 2,
        maxPropertyData: 100,
        maxMapSearchPerMonth: 3,
        maxAISearchPerMonth: 3,
    },
    {
        priceId:
            process.env.REACT_APP_NODE_ENV === 'production'
                ? {
                      month: 'price_1PAalMHfaSP6XcAkXWhcX4DI',
                      year: 'price_1PAalMHfaSP6XcAkAIV8xnUc',
                  }
                : {
                      month: 'price_1OzKieHfaSP6XcAkto2cMA20',
                      year: 'price_1P7PTpHfaSP6XcAkqjQrQLAP',
                  },
        icon: '/image/Plan/Plan-Basic-Icon.png',
        title: 'Basic',
        description: 'Ideal for growing businesses',
        pricePerMonth: 49,
        pricePerYear: 288,
        pricePerYearMonthly: 24,
        maxSwapCount: 5,
        maxPropertyData: MAX_LIMIT,
        maxMapSearchPerMonth: MAX_LIMIT,
        maxAISearchPerMonth: MAX_LIMIT,
    },
    {
        priceId:
            process.env.REACT_APP_NODE_ENV === 'production'
                ? {
                      month: 'price_1PAalLHfaSP6XcAkksM1A1Q5',
                      year: 'price_1PAalLHfaSP6XcAk1HBPcOPG',
                  }
                : {
                      month: 'price_1OzKk7HfaSP6XcAkuRsUDush',
                      year: 'price_1P7PScHfaSP6XcAk7gdqzBZZ',
                  },
        icon: '/image/Plan/Plan-Standard-Icon.png',
        title: 'Standard',
        description: 'Best for established businesses',
        pricePerMonth: 99,
        pricePerYear: 720,
        pricePerYearMonthly: 60,
        maxSwapCount: 100,
        maxPropertyData: MAX_LIMIT,
        maxMapSearchPerMonth: MAX_LIMIT,
        maxAISearchPerMonth: MAX_LIMIT,
    },
    {
        priceId:
            process.env.REACT_APP_NODE_ENV === 'production'
                ? {
                      month: 'price_1PAalJHfaSP6XcAkGmEB7egg',
                      year: 'price_1PAalJHfaSP6XcAk0qyplya6',
                  }
                : {
                      month: 'price_1OzKlaHfaSP6XcAkoBtJ7XWq',
                      year: 'price_1P7PS1HfaSP6XcAkatFwfHNu',
                  },
        icon: '/image/Plan/Plan-Premium-Icon.png',
        title: 'Premium',
        description: 'Ultimate data experience',
        pricePerMonth: 149,
        pricePerYear: 1392,
        pricePerYearMonthly: 116,
        maxSwapCount: MAX_LIMIT,
        maxPropertyData: MAX_LIMIT,
        maxMapSearchPerMonth: MAX_LIMIT,
        maxAISearchPerMonth: MAX_LIMIT,
    },
];

export const FAV_PREFIX = 'http://www.google.com/s2/favicons?domain=';
export const USER_NOT_FOUND_MESSAGE = 'User not found';

export interface PropertyTypeGroup {
    name: string;
    types: string[];
}

export const PROPERTY_TYPE_GROUPS: PropertyTypeGroup[] = [
    {
        name: 'House',
        types: ['Detached house', 'Villa', 'Terraced house', 'Country house', 'Townhouse', 'Castle', 'Bungalow', 'Semi-detached house'],
    },
    {
        name: 'Apartment',
        types: ['Apartment', 'Flat', 'Penthouse', 'Maisonette', 'Loft', 'Attic Apartment'],
    },
    {
        name: 'Land',
        types: ['Land', 'Plot', 'Agricultural and forestry'],
    },
    {
        name: 'Commercial',
        types: ['Commercial Space', 'Office', 'Industry', 'Gastronomy', 'Hotel', 'Storage rooms', 'Garages'],
    },
    {
        name: 'Special',
        types: ['Special property', 'Parking', 'Investment', 'Other'],
    },
];

export const MALLORCA_NOT_DEFINED_LOCATIONS: string[] = [
    'Southwest',
    'Palma',
    'Center',
    'East',
    'Ibiza',
    'Northeast',
    'Northwest',
    'North',
    'West',
    'South',
    'Southeast',
];

// Flatten the types for backward compatibility
export const PROPERTY_TYPES = PROPERTY_TYPE_GROUPS.flatMap((group) => group.types);

export const NO_PLOT_AREA_PROPERTY_TYPES = ['Apartment', 'Flat', 'Penthouse', 'Maisonette', 'Loft', 'Attic Apartment'];

export const SALE_TYPE = ['Sale', 'Rental'];

export const AVAILABILITY_TYPES = ['Available', 'Rented', 'Reserved', 'Sold'];

export const DEFAULT_FROMTO_TYPE = {
    from: 0,
    to: 0,
};

export const DEFAULT_AGENT_FILTER: AgentFilterType = {
    country: '',
    city: '',
    searchTerm: '',
};

export const DEFAULT_FILTER: FilterType = {
    country: '',
    city: [],
    state: [],
    type: [], //property type
    price: DEFAULT_FROMTO_TYPE,
    constructionArea: DEFAULT_FROMTO_TYPE,
    plotArea: DEFAULT_FROMTO_TYPE,
    pricePerSquareMeter: DEFAULT_FROMTO_TYPE,
    bedbath: { bedIdx: [0], bathIdx: [0] },
    listingType: '',
    neighborhood: [],
    locations: [],
    availability: ['available'],
};

export const DEFAULT_SORT: SortDTO = {
    field: 'PropertyCreatedAt',
    order: 'DESC',
};

export const ExtraCountryCodes: { [key: string]: string } = {
    Unknown: '',
    'United States': 'US',
    'United Kingdom': 'GB',
    Bolivia: 'BO',
    'The Bahamas': 'BS',
    'Hong Kong SAR': 'HK',
    'Hong Kong': 'HK',
    Iran: 'IR',
    // Add other countries as needed
};
